export default {
  'Custom': 'Personalizzato',
  'Original': 'Originale',
}